import { LOCALE } from 'interfaces/types'

// CONFIG FOR ONBOARDING FLOW
export const ALLOW_ONBOARDING_WHEN_FIRST_LOGIN_LOCALE_LIST = [
  LOCALE.Vietnam,
] as string[]
export const MARKET_HAS_COMMUNITY = [
  LOCALE.PhilippinesEnglish,
  LOCALE.Thailand,
  LOCALE.Malaysia,
  LOCALE.Indonesia,
  LOCALE.Myanmar,
  LOCALE.Vietnam,
] as string[]

// CONFIG FOR SHOW ASK QUESTION OPTION ON CREATE POST
export const ALLOW_ASK_QUESTIONS_LOCALE_LIST = [
  LOCALE.Vietnam,
  LOCALE.Indonesia,
  LOCALE.Malaysia,
] as string[]

export const MARKET_HAS_HEALTH_APP = [LOCALE.Vietnam] as string[]
export const ALLOW_PREMIUM_NEWSLETTER_LOCALE_LIST = [] as string[]
export const SOYA_HASH_TO_OPEN_LEAD_MODAl = 'open-lead'
export const SOYA_AI_CHAT_ID = 'aiChatId'
export const ALLOW_AIR_POPUPLATION = [LOCALE.Vietnam]
